<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" type="submit" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">{{editTitle}} Documento {{RefAtestFito}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <!--<img class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <label class="codigo2-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitud}}">{{codigoTipoSolicitud}}</label>-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitudAtestFito | IconoTipoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitudAtestFito | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloEstadoSolicitud}}" />

            </span>
        </h5>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-accent-success animated fadeIn">
                    <div class="card-header"></div>
                    <div class="card-body-detalle">
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label class="col-form-label required-field" for="inpTexto">Descripción</label>
                                <input formControlName="Texto" name="Texto" title="" class="form-control" inputStyleClass="form-control"
                                       [ngClass]="displayFieldCss('Texto')" id="inpTexto" type="text" value="" maxlength="50">

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Texto','required')">
                                    Texto es obligatorio
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label class="col-form-label required-field" for="intEstado">Documento</label>
                                <app-document-uploader [parentForm]="form" [parentSubmitted]="submitted" [readOnly]="!habilitarGuardar" [uploadedFile]="uploadedFile" [megaSizeLimit]="megaSizeLimit" (fileUploaded)="onFileUploaded($event)"></app-document-uploader>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
